// import "./App.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./components/Authentication/AuthContext";
// import PrivateRoute from "./components/Authentication/PrivateRoute";
// import Layout from "./components/Common/Layout";
// import { ToastContainer } from "react-toastify";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// // import GoogleMapComponent from "./components/GoogleMapComponent";
// import "./api/interceptors";

// // Authentication Components
// import Register from "./components/Authentication/Register";
// import Login from "./components/Authentication/Login";
// import SocialLogin from "./components/Authentication/SocialLogin";
// import VerifyOtp from "./components/Authentication/VerifyOtp";
// import VerifyOtpForgotPassword from "./components/Authentication/VerifyOtpForgotPassword";
// import ForgotPassword from "./components/Authentication/ForgotPassword";
// import ResetPassword from "./components/Authentication/ResetPassword";

// // Main Components
// import Home from "./components/Home/Home";
// import MainMenu from "./components/MainMenu";
// import UpswapFeatures from "./components/UpswapFeatures";
// import MyActivities from "./components/Activities/MyActivities";
// import MyPersonalAccount from "./components/MyPersonalAccount";
// import UserProfile from "./components/UserProfile";
// import UpswapVendors from "./components/UpswapVendors";
// // import Activities from "./components/Activities";
// import DealsPage from "./components/DealsPage";
// import Header from "./components/Dashboard/Header";
// import Footer from "./components/Dashboard/Footer";
// import Discover from "./components/Dashboard/DiscoverPage";
// import Deals from "./components/Dashboard/Deals";
// import Activities from "./components/Dashboard/Activities";
// import Vendor from "./components/Dashboard/Vendor";

// // Vendor KYC Components
// import BasicInfo from "./components/VendorKYC/BasicInfo";
// import VendorDocument from "./components/VendorKYC/VendorDocument";
// import BankDetails from "./components/VendorKYC/BankDetails";
// import ServiceTime from "./components/VendorKYC/ServiceTime";
// import AddAddress from "./components/VendorKYC/AddAddress";
// import AddService from "./components/VendorKYC/AddService";

// // Deals Components
// import PostDeal from "./components/Deals/PostDeal";
// import PostDealNext from "./components/Deals/PostDealNext";
// import MyDeals from "./components/Deals/MyDeals";
// import DealDetails from "./components/DealDetails";

// import Favorite from "./components/Favorite";
// import Unfavorite from "./components/Unfavorite";
// import VendorProfile from "./components/VendorProfile";

// // Activities Components
// import PostActivities from "./components/Activities/PostActivities";
// import PostActivitiesnext from "./components/Activities/PostActivitiesnext";
// import ActivitiesPage from "./components/Activities/ActivitiesPage";
// import ActivitiesDetails from "./components/Activities/ActivitiesDetails";

// // Chatting Components

// import ChatRoom from "./components/Activities/ChatRoom";

// function App() {
//   return (
//     <AuthProvider>
//       <GoogleOAuthProvider clientId="241793290888-p8ba5p5ucgn1f5mj8un3h71u6a52chkg.apps.googleusercontent.com">
//         {/* <GoogleMapComponent /> */}
//         <Router>
//           <ToastContainer
//             position="top-center"
//             autoClose={3000}
//             hideProgressBar={false}
//             newestOnTop={false}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />

//           <Routes>
//             {/* Public Routes */}
//               <Route path="/login" element={<Login />} />
//             <Route path="/" element={<Layout />} />
//             <Route path="/Register" element={<Register />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/SocialLogin" element={<SocialLogin />} />
//             <Route path="/VerifyOtp" element={<VerifyOtp />} />
//             <Route
//               path="/VerifyOtpForgotPassword"
//               element={<VerifyOtpForgotPassword />}
//             />
//             <Route path="/ForgotPassword" element={<ForgotPassword />} />
//             <Route path="/ResetPassword" element={<ResetPassword />} />

//             {/* Protected Routes */}
//             <Route element={<PrivateRoute />}>
//               <Route element={<Layout />}>
//                 {/* Home Routes */}
//                 <Route path="/Home" element={<Home />} />
//                 <Route path="Discover" element={<Discover />} />
//                 <Route path="Deals" element={<Deals />} />
//                 <Route path="Activities" element={<Activities />} />
//                 <Route path="Vendor" element={<Vendor />} />
//                  <Route path="Header" element={<Header />} />
//                 <Route path="Footer" element={<Footer />} />
//                 {/* Main Routes */}
//                 <Route path="MainMenu" element={<MainMenu />} />
//                 <Route path="UpswapFeatures" element={<UpswapFeatures />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 <Route
//                   path="MyPersonalAccount"
//                   element={<MyPersonalAccount />}
//                 />
//                 <Route path="UserProfile" element={<UserProfile />} />
//                 <Route path="UpswapVendors" element={<UpswapVendors />} />
//                 {/* <Route path="Activities" element={<Activities />} /> */}
//                 <Route path="DealsPage" element={<DealsPage />} />

//                 {/* Vendor KYC Routes */}
//                 <Route path="BasicInfo" element={<BasicInfo />} />
//                 <Route path="VendorDocument" element={<VendorDocument />} />
//                 <Route path="BankDetails" element={<BankDetails />} />
//                 <Route path="ServiceTime" element={<ServiceTime />} />
//                 <Route path="AddAddress" element={<AddAddress />} />
//                 <Route path="AddService" element={<AddService />} />

//                 {/* Deals Routes */}
//                 <Route path="PostDeal" element={<PostDeal />} />
//                 <Route path="PostDealNext" element={<PostDealNext />} />
//                 <Route
//                   path="DealDetails/:deal_uuid"
//                   element={<DealDetails />}
//                 />
//                 <Route path="/DealsPage" element={<DealsPage />} />
//                 <Route path="MyDeals" element={<MyDeals />}></Route>
//                 <Route path="/MyDeals/live" element={<MyDeals type="live" />} />
//                 <Route
//                   path="/MyDeals/scheduled"
//                   element={<MyDeals type="scheduled" />}
//                 />
//                 <Route
//                   path="/MyDeals/history"
//                   element={<MyDeals type="history" />}
//                 />
//                 <Route path="/MyDeals/all" element={<MyDeals type="all" />} />

//                 {/* Activities Routes */}
//                 <Route path="PostActivities" element={<PostActivities />} />
//                 <Route
//                   path="PostActivitiesnext"
//                   element={<PostActivitiesnext />}
//                 />
//                 <Route path="ActivitiesPage" element={<ActivitiesPage />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 {/* <Route
//                   path="PostedActivities"
//                   element={<MyActivities type="PostedActivities" />}
//                 /> */}
//                 {/* MyActivities Routes */}
//                 <Route path="/MyActivities/All" element={<MyActivities />} />
//                 <Route path="/MyActivities/Live" element={<MyActivities />} />
//                 <Route
//                   path="/MyActivities/Participation"
//                   element={<MyActivities />}
//                 />
//                 <Route
//                   path="/MyActivities/History"
//                   element={<MyActivities />}
//                 />
//                 <Route path="/MyActivities/:type" element={<MyActivities />} />

//                 <Route
//                   path="/ActivitiesDetails/:activityId"
//                   element={<ActivitiesDetails />}
//                 />

//                 <Route path="ChatRoom" element={<ChatRoom />} />
//                 <Route
//                   path="/chat/:activityId/:chatroomId"
//                   element={<ChatRoom />}
//                 />

//                 <Route path="Favorite" element={<Favorite />} />
//                 <Route path="Unfavorite" element={<Unfavorite />} />
//                 {/* <Route path="Vendors" element={<Vendors />} /> */}
//                 <Route path="/vendor/:userId" element={<VendorProfile />} />
//                 <Route
//                   path="/VendorProfile/:vendorId"
//                   element={<VendorProfile />}
//                 />
//               </Route>
//             </Route>
//           </Routes>
//         </Router>
//       </GoogleOAuthProvider>
//     </AuthProvider>
//   );
// }

// export default App;

// src/App.js
// import "./App.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./components/Authentication/AuthContext"; // Ensure correct import path
// // import { useAuth } from '../Authentication/AuthContext';
// import PrivateRoute from "./components/Authentication/PrivateRoute";
// import Layout from "./components/Common/Layout"; // Layout will now render the conditional Header
// import { ToastContainer } from "react-toastify";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// import "./api/interceptors"; // Make sure this path is correct if you use interceptors

// // Authentication Components
// import Register from "./components/Authentication/Register";
// import Login from "./components/Authentication/Login";
// import SocialLogin from "./components/Authentication/SocialLogin";
// import VerifyOtp from "./components/Authentication/VerifyOtp";
// import VerifyOtpForgotPassword from "./components/Authentication/VerifyOtpForgotPassword";
// import ForgotPassword from "./components/Authentication/ForgotPassword";
// import ResetPassword from "./components/Authentication/ResetPassword";

// // Main Components
// import Home from "./components/Home/Home";
// import UserHeader from "./components/Dashboard/UserHeader";
// import VendorHeader from "./components/Dashboard/VendorHeader";
// import MainMenu from "./components/MainMenu"; // Check if this is still needed or replaced by Header navigation
// import UpswapFeatures from "./components/UpswapFeatures";
// import MyActivities from "./components/Activities/MyActivities";
// import MyPersonalAccount from "./components/MyPersonalAccount";
// import UserProfile from "./components/UserProfile";
// import UpswapVendors from "./components/UpswapVendors";
// import DealsPage from "./components/DealsPage";
// import Discover from "./components/Dashboard/DiscoverPage";
// import ExclusiveDeals from "./components/Dashboard/ExclusiveDeals";
// import Activities from "./components/Dashboard/Activities";
// import Vendor from "./components/Dashboard/Vendor";
// import VendorDashboard from "./components/VendorDashboard";

// // Vendor KYC Components (Make sure these paths are correct relative to App.js)
// import BasicInfo from "./components/VendorKYC/BasicInfo";
// import VendorDocument from "./components/VendorKYC/VendorDocument";
// import BankDetails from "./components/VendorKYC/BankDetails";
// import ServiceTime from "./components/VendorKYC/ServiceTime";
// import AddAddress from "./components/VendorKYC/AddAddress";
// import AddService from "./components/VendorKYC/AddService";

// // Deals Components
// import PostDeal from "./components/Deals/PostDeal";
// import PostDealNext from "./components/Deals/PostDealNext";
// import MyDeals from "./components/Deals/MyDeals";
// import DealDetails from "./components/DealDetails";
// import PopularDeals from "./components/Deals/PopularDeals";

// import Favorite from "./components/Favorite";
// import Unfavorite from "./components/Unfavorite";
// import VendorProfile from "./components/VendorProfile";

// // Activities Components
// import LocalActivities from "./components/Activities/LocalActivities";
// import PostActivities from "./components/Activities/PostActivities";
// import PostActivitiesnext from "./components/Activities/PostActivitiesnext";
// import ActivitiesPage from "./components/Activities/ActivitiesPage";
// import ActivitiesDetails from "./components/Activities/ActivitiesDetails";

// // Chatting Components
// import ChatRoom from "./components/Activities/ChatRoom";

// function App() {
//   return (
//     <AuthProvider>
//       {" "}
//       {/* AuthProvider wraps the entire application */}
//       <GoogleOAuthProvider clientId="241793290888-p8ba5p5ucgn1f5mj8un3h71u6a52chkg.apps.googleusercontent.com">
//         <Router>
//           <ToastContainer
//             position="top-center"
//             autoClose={3000}
//             hideProgressBar={false}
//             newestOnTop={false}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />

//           <Routes>
//             {/* Routes that use the common Layout (which includes your Header) */}
//             <Route element={<Layout />}>
//               {/* Public Routes */}
//               <Route path="/" element={<Home />} />
//               <Route path="/login" element={<Login />} />
//               <Route path="/Register" element={<Register />} />
//               <Route path="/SocialLogin" element={<SocialLogin />} />
//               <Route path="/VerifyOtp" element={<VerifyOtp />} />
//               <Route
//                 path="/VerifyOtpForgotPassword"
//                 element={<VerifyOtpForgotPassword />}
//               />
//               <Route path="/ForgotPassword" element={<ForgotPassword />} />
//               <Route path="/ResetPassword" element={<ResetPassword />} />
//               <Route
//                 path="/ActivitiesDetails/:activityId"
//                 element={<ActivitiesDetails />}
//               />
//               <Route path="DealDetails/:deal_uuid" element={<DealDetails />} />
//               <Route path="/Home" element={<Home />} />{" "}
//               {/* Redundant if / is home, but kept as in your code */}
//               <Route path="UpswapVendors" element={<UpswapVendors />} />
//               <Route path="UserHeader" element={<UserHeader />} />
//               <Route path="VendorHeader" element={<VendorHeader />} />
//               <Route path="/vendor/:userId" element={<VendorProfile />} />
//               <Route
//                 path="/VendorProfile/:vendorId"
//                 element={<VendorProfile />}
//               />
//                <Route path="LocalActivities" element={<LocalActivities />} />
//               <Route path="Vendor" element={<Vendor />} />
//               <Route path="Activities" element={<Activities />} />
//               <Route path="ExclusiveDeals" element={<ExclusiveDeals />} />
//               <Route path="Favorite" element={<Favorite />} />
//               <Route path="Unfavorite" element={<Unfavorite />} />
//               <Route path="VendorDashboard" element={<VendorDashboard />} />
//               <Route path="UserProfile" element={<UserProfile />} />
//               {/* Protected Routes (nested within Layout and PrivateRoute) */}
//               <Route element={<PrivateRoute />}>
//                 {/* Dashboard / Main Logged-in Routes */}
//                 <Route path="Discover" element={<Discover />} />
//                 {/* <Route path="ExclusiveDeals" element={<ExclusiveDeals />} /> */}
//                 {/* <Route path="Activities" element={<Activities />} /> */}

//                 {/* Main Menu related (check if still needed) */}
//                 <Route path="MainMenu" element={<MainMenu />} />
//                 <Route path="UpswapFeatures" element={<UpswapFeatures />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 <Route
//                   path="MyPersonalAccount"
//                   element={<MyPersonalAccount />}
//                 />

//                 <Route path="DealsPage" element={<DealsPage />} />

//                 {/* Vendor KYC Routes */}
//                 <Route path="BasicInfo" element={<BasicInfo />} />
//                 <Route path="VendorDocument" element={<VendorDocument />} />
//                 <Route path="BankDetails" element={<BankDetails />} />
//                 <Route path="ServiceTime" element={<ServiceTime />} />
//                 <Route path="AddAddress" element={<AddAddress />} />
//                 <Route path="AddService" element={<AddService />} />

//                 {/* Deals Routes */}
//                 <Route path="PostDeal" element={<PostDeal />} />
//                 <Route path="PopularDeals" element={<PopularDeals />} />
//                 <Route path="PostDealNext" element={<PostDealNext />} />
//                 <Route path="/DealsPage" element={<DealsPage />} />
//                 <Route path="MyDeals" element={<MyDeals />}></Route>
//                 <Route path="/MyDeals/live" element={<MyDeals type="live" />} />
//                 <Route
//                   path="/MyDeals/scheduled"
//                   element={<MyDeals type="scheduled" />}
//                 />
//                 <Route
//                   path="/MyDeals/history"
//                   element={<MyDeals type="history" />}
//                 />
//                 <Route path="/MyDeals/all" element={<MyDeals type="all" />} />

//                 {/* Activities Routes */}

//                 <Route path="PostActivities" element={<PostActivities />} />
//                 <Route
//                   path="PostActivitiesnext"
//                   element={<PostActivitiesnext />}
//                 />
//                 <Route path="ActivitiesPage" element={<ActivitiesPage />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 <Route path="/MyActivities/All" element={<MyActivities />} />
//                 <Route path="/MyActivities/Live" element={<MyActivities />} />
//                 <Route
//                   path="/MyActivities/Participation"
//                   element={<MyActivities />}
//                 />
//                 <Route
//                   path="/MyActivities/History"
//                   element={<MyActivities />}
//                 />
//                 <Route path="/MyActivities/:type" element={<MyActivities />} />

//                 {/* Chatting Components */}
//                 <Route path="ChatRoom" element={<ChatRoom />} />
//                 <Route
//                   path="/chat/:activityId/:chatroomId"
//                   element={<ChatRoom />}
//                 />
//               </Route>
//             </Route>
//           </Routes>
//         </Router>
//       </GoogleOAuthProvider>
//     </AuthProvider>
//   );
// }

// export default App;

// src/App.js
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./components/Authentication/AuthContext"; // Ensure correct import path
import PrivateRoute from "./components/Authentication/PrivateRoute";
import Layout from "./components/Common/Layout"; // Layout will now render the conditional Header
import { ToastContainer } from "react-toastify";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./api/interceptors"; // Make sure this path is correct if you use interceptors

// Authentication Components
import Register from "./components/Authentication/Register";
import Login from "./components/Authentication/Login";
import SocialLogin from "./components/Authentication/SocialLogin";
import VerifyOtp from "./components/Authentication/VerifyOtp";
import VerifyOtpForgotPassword from "./components/Authentication/VerifyOtpForgotPassword";
import ForgotPassword from "./components/Authentication/ForgotPassword";
import ResetPassword from "./components/Authentication/ResetPassword";

// Main Components
import Home from "./components/Home/Home";
// UserHeader and VendorHeader are now handled conditionally within Layout
// import UserHeader from "./components/Dashboard/UserHeader";
// import VendorHeader from "./components/Dashboard/VendorHeader";

import MainMenu from "./components/MainMenu"; // Check if this is still needed or replaced by Header navigation
import UpswapFeatures from "./components/UpswapFeatures";
import MyActivities from "./components/Activities/MyActivities"; // This component will read filter from location.state
import MyPersonalAccount from "./components/MyPersonalAccount";
import UserProfile from "./components/UserProfile";
import UpswapVendors from "./components/UpswapVendors";
import DealsPage from "./components/DealsPage";
import Discover from "./components/Dashboard/DiscoverPage";
import ExclusiveDeals from "./components/Dashboard/ExclusiveDeals";
import Activities from "./components/Dashboard/Activities"; // Likely LocalActivities for browsing
import Vendor from "./components/Dashboard/Vendor"; // Assuming this is for a specific vendor profile
import PopularVendors from "./components/Dashboard/PopularVendors";
import VendorDashboard from "./components/VendorDashboard";
import StateSection from "./components/Dashboard/StateSection";
import PopularCategories from "./components/Dashboard/PopularCategories ";
import HowItWorks from "./components/Dashboard/HowItWorks";
import CommunitySection from "./components/Dashboard/CommunitySection";
import Settings from "./components/Settings";
import ContactSupport from "./components/ContactSupport";

// Vendor KYC Components (Make sure these paths are correct relative to App.js)
import BasicInfo from "./components/VendorKYC/BasicInfo";
import VendorDocument from "./components/VendorKYC/VendorDocument";
import BankDetails from "./components/VendorKYC/BankDetails";
import ServiceTime from "./components/VendorKYC/ServiceTime";
import AddAddress from "./components/VendorKYC/AddAddress";
import AddService from "./components/VendorKYC/AddService";

// Deals Components
import PostDeal from "./components/Deals/PostDeal";
import PostDealNext from "./components/Deals/PostDealNext";
import MyDeals from "./components/Deals/MyDeals"; // This component will read type from location.state
import DealDetails from "./components/DealDetails";
import PopularDeals from "./components/Deals/PopularDeals";

import Favorite from "./components/Favorite";
import Unfavorite from "./components/Unfavorite";
import VendorProfile from "./components/VendorProfile";

// Activities Components
import LocalActivities from "./components/Activities/LocalActivities"; // "Browse Activities"
import PostActivities from "./components/Activities/PostActivities"; // "Create Activity"
import PostActivitiesnext from "./components/Activities/PostActivitiesnext"; // Assuming this is a follow-up to PostActivities
import ActivitiesPage from "./components/Activities/ActivitiesPage"; // If different from LocalActivities
import ActivitiesDetails from "./components/Activities/ActivitiesDetails"; // Activity details page

// Chatting Components
import ChatRoom from "./components/Activities/ChatRoom";
import BrowseService from "./components/Services/BrowseService";
import VendorHomePageDashboard from "./components/Vendor/VendorHomePageDashboard";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import VendorServiceViewWrapper from "./components/Vendor/VendorServices/View/VendorServiceViewWrapper";
import AddDealFormWrapper from "./components/Vendor/VendorDeal/Add/AddDealFormWrapper";
import { ActivitiesDetailView } from "./components/Customer/Activities/ActivitiesDetailView";
import ActivityAddFormWrapper from "./components/Customer/Activities/Add/ActivityAddFormWrapper";
function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        {/* AuthProvider wraps the entire application to provide auth context */}
        <GoogleOAuthProvider clientId="241793290888-p8ba5p5ucgn1f5mj8un3h71u6a52chkg.apps.googleusercontent.com">
          <Router>
            <Toaster position="top-right" expand={true} richColors />
            {/* Toast container for notifications */}
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />

            <Routes>
              {/* Routes that use the common Layout (which includes your Header) */}
              <Route element={<Layout />}>
                {/* Public Routes - accessible by anyone */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/Register" element={<Register />} />
                <Route path="/SocialLogin" element={<SocialLogin />} />
                <Route path="/VerifyOtp" element={<VerifyOtp />} />
                <Route
                  path="/VerifyOtpForgotPassword"
                  element={<VerifyOtpForgotPassword />}
                />
                <Route path="/ForgotPassword" element={<ForgotPassword />} />
                <Route path="/ResetPassword" element={<ResetPassword />} />
                <Route
                  path="/ActivitiesDetails/:activityId"
                  element={<ActivitiesDetailView />}
                />
                <Route path="/ChatRoom" element={<ChatRoom />} />
                <Route
                  path="/chat/:activityId/:chatroomId"
                  element={<ChatRoom />}
                />
                <Route
                  path="/DealDetails/:deal_uuid"
                  element={<DealDetails />}
                />
                <Route path="/Home" element={<Home />} />{" "}
                {/* Redundant if / is home, but kept as in your code */}
                <Route path="/UpswapVendors" element={<UpswapVendors />} />
                {/* UserHeader and VendorHeader should not be routed directly here as elements, they are part of Layout's conditional rendering */}
                {/* <Route path="/UserHeader" element={<UserHeader />} /> */}
                {/* <Route path="/VendorHeader" element={<VendorHeader />} /> */}
                <Route path="/vendor/:userId" element={<VendorProfile />} />
                <Route
                  path="/vendor/dashboard"
                  element={<VendorHomePageDashboard />}
                />
                <Route
                  path="/vendor/services"
                  element={<VendorServiceViewWrapper />}
                />
                <Route
                  path="/vendor/deal/add"
                  element={<AddDealFormWrapper />}
                />
                <Route
                  path="/vendor/activity/add"
                  element={<ActivityAddFormWrapper />}
                />
                <Route
                  path="/VendorProfile/:vendorId"
                  element={<VendorProfile />}
                />
                <Route path="/PopularDeals" element={<PopularDeals />} />
                <Route path="/StateSection" element={<StateSection />} />{" "}
                <Route
                  path="/PopularCategories "
                  element={<PopularCategories />}
                />{" "}
                <Route
                  path="MyPersonalAccount"
                  element={<MyPersonalAccount />}
                />
                <Route path="/LocalActivities" element={<LocalActivities />} />{" "}
                {/* Browse Activities */}
                <Route path="/Vendor" element={<Vendor />} />
                <Route path="/PopularVendors" element={<PopularVendors />} />
                <Route path="/Activities" element={<Activities />} />{" "}
                {/* Assuming this is also for browsing activities generally */}
                <Route path="/ExclusiveDeals" element={<ExclusiveDeals />} />
                <Route path="/Favorite" element={<Favorite />} />
                <Route path="/Unfavorite" element={<Unfavorite />} />
                <Route path="/VendorDashboard" element={<VendorDashboard />} />
                <Route path="/UserProfile" element={<UserProfile />} />
                <Route path="/HowItWorks" element={<HowItWorks />} />
                <Route
                  path="/CommunitySection"
                  element={<CommunitySection />}
                />
                <Route
                  path="/PostActivities"
                  element={<ActivityAddFormWrapper />}
                />
                <Route
                  path="/PostActivitiesnext"
                  element={<PostActivitiesnext />}
                />
                {/* Protected Routes (nested within Layout and PrivateRoute) */}
                <Route
                  path="/MyActivities/:filterType?"
                  element={<MyActivities />}
                />{" "}
                <Route element={<PrivateRoute />}>
                  {/* Dashboard / Main Logged-in Routes */}
                  <Route path="/Discover" element={<Discover />} />
                  {/* Main Menu related (check if still needed) */}
                  <Route path="/MainMenu" element={<MainMenu />} />
                  <Route path="/UpswapFeatures" element={<UpswapFeatures />} />
                  <Route
                    path="/MyPersonalAccount"
                    element={<MyPersonalAccount />}
                  />
                  <Route path="/ContactSupport" element={<ContactSupport />} />
                  <Route path="/Settings" element={<Settings />} />
                  <Route path="/DealsPage" element={<DealsPage />} />
                  {/* Vendor KYC Routes */}
                  <Route path="/BasicInfo" element={<BasicInfo />} />
                  <Route path="/VendorDocument" element={<VendorDocument />} />
                  <Route path="/BankDetails" element={<BankDetails />} />
                  <Route path="/ServiceTime" element={<ServiceTime />} />
                  <Route path="/AddAddress" element={<AddAddress />} />
                  <Route path="/AddService" element={<AddService />} />
                  {/* Deals Routes - Consolidating MyDeals paths */}
                  <Route path="/PostDeal" element={<PostDeal />} />
                  <Route path="/PostDealNext" element={<PostDealNext />} />
                  {/* MyDeals will now handle filtering based on location.state.type */}
                  <Route path="/MyDeals/:type?" element={<MyDeals />} />{" "}
                  {/* Optional type parameter, MyDeals will read state */}
                  {/* Activities Routes - Consolidating MyActivities paths */}
                  <Route path="/services/browse" element={<BrowseService />} />
                  <Route path="/ActivitiesPage" element={<ActivitiesPage />} />
                  {/* MyActivities will now handle filtering based on location.state.filter */}
                  {/* Optional filterType parameter, MyActivities will read state */}
                  {/* Chatting Components */}
                </Route>
              </Route>
            </Routes>
          </Router>
        </GoogleOAuthProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App;

// import "./App.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./components/Authentication/AuthContext";
// import PrivateRoute from "./components/Authentication/PrivateRoute";
// import Layout from "./components/Common/Layout";
// import { ToastContainer } from "react-toastify";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// import "./api/interceptors";

// // Authentication Components
// import Register from "./components/Authentication/Register";
// import Login from "./components/Authentication/Login";
// import SocialLogin from "./components/Authentication/SocialLogin";
// import VerifyOtp from "./components/Authentication/VerifyOtp";
// import VerifyOtpForgotPassword from "./components/Authentication/VerifyOtpForgotPassword";
// import ForgotPassword from "./components/Authentication/ForgotPassword";
// import ResetPassword from "./components/Authentication/ResetPassword";

// // Main Components
// import Home from "./components/Home/Home";
// import MainMenu from "./components/MainMenu";
// import UpswapFeatures from "./components/UpswapFeatures";
// import MyActivities from "./components/Activities/MyActivities";
// import MyPersonalAccount from "./components/MyPersonalAccount";
// import UserProfile from "./components/UserProfile";
// import UpswapVendors from "./components/UpswapVendors";
// import DealsPage from "./components/DealsPage";
// import Discover from "./components/Dashboard/DiscoverPage";
// import ExclusiveDeals from "./components/Dashboard/ExclusiveDeals";
// import Activities from "./components/Dashboard/Activities";
// import Vendor from "./components/Dashboard/Vendor";

// // Vendor KYC Components
// import BasicInfo from "./components/VendorKYC/BasicInfo";
// import VendorDocument from "./components/VendorKYC/VendorDocument";
// import BankDetails from "./components/VendorKYC/BankDetails";
// import ServiceTime from "./components/VendorKYC/ServiceTime";
// import AddAddress from "./components/VendorKYC/AddAddress";
// import AddService from "./components/VendorKYC/AddService";

// // Deals Components
// import PostDeal from "./components/Deals/PostDeal";
// import PostDealNext from "./components/Deals/PostDealNext";
// import MyDeals from "./components/Deals/MyDeals";
// import DealDetails from "./components/DealDetails";
// import PopularDeals from "./components/Deals/PopularDeals";

// import Favorite from "./components/Favorite";
// import Unfavorite from "./components/Unfavorite";
// import VendorProfile from "./components/VendorProfile";

// // Activities Components
// import LocalActivities from "./components/Activities/LocalActivities";
// import PostActivities from "./components/Activities/PostActivities";
// import PostActivitiesnext from "./components/Activities/PostActivitiesnext";
// import ActivitiesPage from "./components/Activities/ActivitiesPage";
// import ActivitiesDetails from "./components/Activities/ActivitiesDetails";
// // import { ActivityDetailsPage } from './components/Activities/ActivityDetailsPage';

// // Chatting Components
// import ChatRoom from "./components/Activities/ChatRoom";

// function App() {
//   return (
//     <AuthProvider>
//       <GoogleOAuthProvider clientId="241793290888-p8ba5p5ucgn1f5mj8un3h71u6a52chkg.apps.googleusercontent.com">
//         <Router>
//           <ToastContainer
//             position="top-center"
//             autoClose={3000}
//             hideProgressBar={false}
//             newestOnTop={false}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />

//           <Routes>
//             {/* Public Routes with Header and Footer */}

//             <Route element={<Layout />}>
//               <Route path="/" element={<Home />} />
//               <Route path="/login" element={<Login />} />
//               <Route path="/Register" element={<Register />} />
//               <Route path="/SocialLogin" element={<SocialLogin />} />
//               <Route path="/VerifyOtp" element={<VerifyOtp />} />
//               <Route
//                 path="/VerifyOtpForgotPassword"
//                 element={<VerifyOtpForgotPassword />}
//               />
//               <Route path="/ForgotPassword" element={<ForgotPassword />} />
//               <Route path="/ResetPassword" element={<ResetPassword />} />
//               <Route
//                 path="/ActivitiesDetails/:activityId"
//                 element={<ActivitiesDetails />}
//               />

//               <Route path="DealDetails/:deal_uuid" element={<DealDetails />} />
//               <Route path="/Home" element={<Home />} />
//               <Route path="UpswapVendors" element={<UpswapVendors />} />
//               <Route path="/vendor/:userId" element={<VendorProfile />} />
//               <Route
//                 path="/VendorProfile/:vendorId"
//                 element={<VendorProfile />}
//               />
//                 <Route path="Favorite" element={<Favorite />} />
//                 <Route path="Unfavorite" element={<Unfavorite />} />
//               {/* Protected Routes */}
//               <Route element={<PrivateRoute />}>
//                 {/* Home Routes */}

//                 <Route path="Discover" element={<Discover />} />
//                 <Route path="ExclusiveDeals" element={<ExclusiveDeals />} />
//                 <Route path="Activities" element={<Activities />} />
//                 <Route path="Vendor" element={<Vendor />} />

//                 {/* Main Routes */}
//                 <Route path="MainMenu" element={<MainMenu />} />
//                 <Route path="UpswapFeatures" element={<UpswapFeatures />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 <Route
//                   path="MyPersonalAccount"
//                   element={<MyPersonalAccount />}
//                 />
//                 <Route path="UserProfile" element={<UserProfile />} />

//                 <Route path="DealsPage" element={<DealsPage />} />

//                 {/* Vendor KYC Routes */}
//                 <Route path="BasicInfo" element={<BasicInfo />} />
//                 <Route path="VendorDocument" element={<VendorDocument />} />
//                 <Route path="BankDetails" element={<BankDetails />} />
//                 <Route path="ServiceTime" element={<ServiceTime />} />
//                 <Route path="AddAddress" element={<AddAddress />} />
//                 <Route path="AddService" element={<AddService />} />

//                 {/* Deals Routes */}
//                 <Route path="PostDeal" element={<PostDeal />} />
//                 <Route path="PopularDeals" element={<PopularDeals />} />
//                 <Route path="PostDealNext" element={<PostDealNext />} />

//                 <Route path="/DealsPage" element={<DealsPage />} />
//                 <Route path="MyDeals" element={<MyDeals />}></Route>
//                 <Route path="/MyDeals/live" element={<MyDeals type="live" />} />
//                 <Route
//                   path="/MyDeals/scheduled"
//                   element={<MyDeals type="scheduled" />}
//                 />
//                 <Route
//                   path="/MyDeals/history"
//                   element={<MyDeals type="history" />}
//                 />
//                 <Route path="/MyDeals/all" element={<MyDeals type="all" />} />

//                 {/* Activities Routes */}
//                 <Route path="LocalActivities" element={<LocalActivities />} />
//                 <Route path="PostActivities" element={<PostActivities />} />
//                 <Route
//                   path="PostActivitiesnext"
//                   element={<PostActivitiesnext />}
//                 />
//                 <Route path="ActivitiesPage" element={<ActivitiesPage />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 <Route path="/MyActivities/All" element={<MyActivities />} />
//                 <Route path="/MyActivities/Live" element={<MyActivities />} />
//                 <Route
//                   path="/MyActivities/Participation"
//                   element={<MyActivities />}
//                 />
//                 <Route
//                   path="/MyActivities/History"
//                   element={<MyActivities />}
//                 />
//                 <Route path="/MyActivities/:type" element={<MyActivities />} />

//                 <Route path="ChatRoom" element={<ChatRoom />} />
//                 <Route
//                   path="/chat/:activityId/:chatroomId"
//                   element={<ChatRoom />}
//                 />
//                  {/* <Route path="ActivityDetailsPage" element={<ActivityDetailsPage />} /> */}

//               </Route>
//             </Route>
//           </Routes>
//         </Router>
//       </GoogleOAuthProvider>
//     </AuthProvider>
//   );
// }

// export default App;

// import "./App.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./components/Authentication/AuthContext";
// import PrivateRoute from "./components/Authentication/PrivateRoute";
// import Layout from "./components/Common/Layout";
// import { ToastContainer } from "react-toastify";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// import "./api/interceptors";

// // Authentication Components
// import Register from "./components/Authentication/Register";
// import Login from "./components/Authentication/Login";
// import SocialLogin from "./components/Authentication/SocialLogin";
// import VerifyOtp from "./components/Authentication/VerifyOtp";
// import VerifyOtpForgotPassword from "./components/Authentication/VerifyOtpForgotPassword";
// import ForgotPassword from "./components/Authentication/ForgotPassword";
// import ResetPassword from "./components/Authentication/ResetPassword";

// // Main Components
// import MainMenu from "./components/MainMenu";
// import UpswapFeatures from "./components/UpswapFeatures";
// import MyActivities from "./components/Activities/MyActivities";
// import MyPersonalAccount from "./components/MyPersonalAccount";
// import UserProfile from "./components/UserProfile";
// import UpswapVendors from "./components/UpswapVendors";
// import DealsPage from "./components/DealsPage";
// import Discover from "./components/Dashboard/DiscoverPage";
// import Deals from "./components/Dashboard/Deals";
// import Activities from "./components/Dashboard/Activities";
// import Vendor from "./components/Dashboard/Vendor";
// import Footer from "./components/Dashboard/Footer";

// // Vendor KYC Components
// import BasicInfo from "./components/VendorKYC/BasicInfo";
// import VendorDocument from "./components/VendorKYC/VendorDocument";
// import BankDetails from "./components/VendorKYC/BankDetails";
// import ServiceTime from "./components/VendorKYC/ServiceTime";
// import AddAddress from "./components/VendorKYC/AddAddress";
// import AddService from "./components/VendorKYC/AddService";

// // Deals Components
// import PostDeal from "./components/Deals/PostDeal";
// import PostDealNext from "./components/Deals/PostDealNext";
// import MyDeals from "./components/Deals/MyDeals";
// import DealDetails from "./components/DealDetails";

// // Activities Components
// import PostActivities from "./components/Activities/PostActivities";
// import PostActivitiesnext from "./components/Activities/PostActivitiesnext";
// import ActivitiesPage from "./components/Activities/ActivitiesPage";
// import ActivitiesDetails from "./components/Activities/ActivitiesDetails";

// // Chatting Components
// import ChatRoom from "./components/Activities/ChatRoom";
// import Favorite from "./components/Favorite";
// import Unfavorite from "./components/Unfavorite";
// import VendorProfile from "./components/VendorProfile";

// function App() {
//   return (
//     <AuthProvider>
//       <GoogleOAuthProvider clientId="241793290888-p8ba5p5ucgn1f5mj8un3h71u6a52chkg.apps.googleusercontent.com">
//         <Router>
//           <ToastContainer
//             position="top-center"
//             autoClose={3000}
//             hideProgressBar={false}
//             newestOnTop={false}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />

//           <Routes>
//             {/* Public Routes */}
//             <Route path="/" element={<Login />} />
//             <Route path="/Register" element={<Register />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/SocialLogin" element={<SocialLogin />} />
//             <Route path="/VerifyOtp" element={<VerifyOtp />} />
//             <Route path="/VerifyOtpForgotPassword" element={<VerifyOtpForgotPassword />} />
//             <Route path="/ForgotPassword" element={<ForgotPassword />} />
//             <Route path="/ResetPassword" element={<ResetPassword />} />

//             {/* Protected Routes */}
//             <Route element={<PrivateRoute />}>
//               <Route element={<Layout />}>
//                 {/* Dashboard/Home Routes */}
//                 <Route path="/Discover" element={<Discover />} />
//                 <Route path="/Deals" element={<Deals />} />
//                 <Route path="/Activities" element={<Activities />} />
//                 <Route path="/Vendor" element={<Vendor />} />
//                 <Route path="Footer" element={<Footer />} />

//                 {/* Main Routes */}
//                 <Route path="MainMenu" element={<MainMenu />} />
//                 <Route path="UpswapFeatures" element={<UpswapFeatures />} />
//                 <Route path="MyActivities" element={<MyActivities />} />
//                 <Route path="MyPersonalAccount" element={<MyPersonalAccount />} />
//                 <Route path="UserProfile" element={<UserProfile />} />
//                 <Route path="UpswapVendors" element={<UpswapVendors />} />
//                 <Route path="DealsPage" element={<DealsPage />} />

//                 {/* Vendor KYC Routes */}
//                 <Route path="BasicInfo" element={<BasicInfo />} />
//                 <Route path="VendorDocument" element={<VendorDocument />} />
//                 <Route path="BankDetails" element={<BankDetails />} />
//                 <Route path="ServiceTime" element={<ServiceTime />} />
//                 <Route path="AddAddress" element={<AddAddress />} />
//                 <Route path="AddService" element={<AddService />} />

//                 {/* Deals Routes */}
//                 <Route path="PostDeal" element={<PostDeal />} />
//                 <Route path="PostDealNext" element={<PostDealNext />} />
//                 <Route path="DealDetails/:deal_uuid" element={<DealDetails />} />
//                 <Route path="MyDeals" element={<MyDeals />} />
//                 <Route path="MyDeals/live" element={<MyDeals type="live" />} />
//                 <Route path="MyDeals/scheduled" element={<MyDeals type="scheduled" />} />
//                 <Route path="MyDeals/history" element={<MyDeals type="history" />} />
//                 <Route path="MyDeals/all" element={<MyDeals type="all" />} />

//                 {/* Activities Routes */}
//                 <Route path="PostActivities" element={<PostActivities />} />
//                 <Route path="PostActivitiesnext" element={<PostActivitiesnext />} />
//                 <Route path="ActivitiesPage" element={<ActivitiesPage />} />
//                 <Route path="ActivitiesDetails/:activityId" element={<ActivitiesDetails />} />

//                 {/* Chat Routes */}
//                 <Route path="ChatRoom" element={<ChatRoom />} />
//                 <Route path="chat/:activityId/:chatroomId" element={<ChatRoom />} />

//                 {/* Favorites */}
//                 <Route path="Favorite" element={<Favorite />} />
//                 <Route path="Unfavorite" element={<Unfavorite />} />

//                 {/* Vendor Profile */}
//                 <Route path="vendor/:userId" element={<VendorProfile />} />
//                 <Route path="VendorProfile/:vendorId" element={<VendorProfile />} />
//               </Route>
//             </Route>
//           </Routes>
//         </Router>
//       </GoogleOAuthProvider>
//     </AuthProvider>
//   );
// }

// export default App;
